export const TemplateIds = {
	GENERAL_TEMPLATE_1: 'general_jsm_template_1',
	GENERAL_TEMPLATE_2: 'general_jsm_template_2',
	GENERAL_TEMPLATE_3: 'general_jsm_template_3',
	HR_TEMPLATE_1: 'hr_template_1',
	HR_TEMPLATE_2: 'hr_template_2',
	HR_TEMPLATE_3: 'hr_template_3',
};
